import * as React from "react";
import * as $ from "jquery";
import { RioForEach, RioApiGet, RioResources, RioUnsafe, RioToggleSwitch } from "rio.react.all";
import { MenuItemApiModel } from "../apiModels/MenuItemApiModel";

interface ISideMenuProps {
    menuItemEndpoint: string;
}

interface ISideMenuState {
    menuItems: Array<MenuItemApiModel>;
    currentItem?: MenuItemApiModel;
    subMenuPinned: boolean;
}

export class SideMenu extends React.Component<ISideMenuProps, ISideMenuState> {
    constructor(props: Readonly<ISideMenuProps>) {
        super(props);
        this.state = {
            menuItems: [],
            currentItem: null,
            subMenuPinned: localStorage.getItem("pinned") === "true" ? true : false
        };
    }

    render() {
        return (
            <React.Fragment>
                <div className="sideMenuPin">
                    <RioToggleSwitch id={"myToggleSwitch"} on={this.state.subMenuPinned} enabled={true} className="" onClick={(item) => this.handlePinClick(item)} />
                </div>
                <div className="sideMenuMainItems">
                    <RioForEach items={this.state.menuItems} perform={(item: MenuItemApiModel) => {
                        return <SideMenuItem item={item} menuItem={item.resourceName} active={item === this.state.currentItem} itemClicked={(item) => this.handleSideMenuItemClicked(item)} itemMiddleClicked={(item) => this.handleSideMenuItemMiddleClicked(item)} key={item.menuItemID} />;
                    }} />
                </div>
                <div className="sideMenuSubItems">
                    {!!this.state.currentItem &&
                        <RioForEach items={this.state.currentItem.childItems} perform={(item: MenuItemApiModel) => {
                        return <SideMenuSubItem item={item} itemClicked={(item) => this.handleSideMenuSubItemClicked(item)} itemMiddleClicked={(item) => this.handleSideMenuSubItemMiddleClicked(item)} key={item.menuItemID} />;
                        }} />
                    }
                </div>
            </React.Fragment>
        );
    }
    
    componentDidMount(): void {
        this.loadMenu();

        $(".mobileSideMenuBurger").off("click").click(function () {
            $(".mobileSideMenuBurger").toggleClass("mobileMenuOpen");
            $(".sideMenu").toggleClass("mobileMenuOpen");
        });

        const mainBody = document.getElementsByTagName("main");
        if (this.state.subMenuPinned) {
            mainBody.item(0).classList.add("pinned");
        }
        else {
            mainBody.item(0).classList.remove("pinned");
        }
    }

    loadMenu() {
        RioApiGet.asPromise<Array<MenuItemApiModel>>(this.props.menuItemEndpoint)
            .then(response => {
                this.setState({
                    menuItems: response,
                });
                this.loadPin();
            });
    }

    handleSideMenuItemClicked(item: MenuItemApiModel): void {
        if (!!item.controllerAction) {
            window.location.href = "/" + item.controllerAction;
            return;
        }

        let newCurrentItem: MenuItemApiModel = item;

        if (this.state.currentItem === item) {
            if (this.state.subMenuPinned) {
                return;
            }
            newCurrentItem = null;
        }

        this.setState({
            currentItem: newCurrentItem
        });

        localStorage.setItem("currentMenu", item.resourceName);

        $("nav").toggleClass("open", !!newCurrentItem && !!newCurrentItem.childItems && newCurrentItem.childItems.length > 0);
        if (this.state.subMenuPinned && !newCurrentItem) {
            $("#myToggleSwitch").click();
        }
    }

    handleSideMenuItemMiddleClicked(item: MenuItemApiModel): void {
        if (!!item.controllerAction){
            window.open("/" + item.controllerAction, "_blank");
            return;
        }
    }

    loadPin() {
        if (this.state.subMenuPinned) {
            $("nav").addClass("open");
            $("#myToggleSwitch").addClass('on ');
            var mainContent = document.getElementsByTagName('nav');
            mainContent.item(0).classList.add('pinned');

            var currentMenu = this.state.menuItems.find(function (element) {
                return element.resourceName === localStorage.getItem("currentMenu");
            });
            this.setState({
                currentItem: currentMenu
            });
        }
    }

    handlePinClick(item: RioToggleSwitch): void {
        this.setState({
            subMenuPinned: !this.state.subMenuPinned
        });

        item.setState({
            classes: ['rioSwitch', (!this.state.subMenuPinned ? 'on ' : '')].join(' ')
        });

        var mainContent = document.getElementsByTagName('nav');

        mainContent.item(0).classList.toggle('pinned');

        localStorage.setItem("pinned", (!this.state.subMenuPinned).toString());
        localStorage.setItem("currentMenu", this.state.currentItem.resourceName);
    }

    handleSideMenuSubItemClicked(item: MenuItemApiModel): void {
        if (!!item.controllerAction) {
            window.location.href = "/" + item.controllerAction;
        }
    }

    handleSideMenuSubItemMiddleClicked(item: MenuItemApiModel): void {
        if (!!item.controllerAction) {
            window.open("/" + item.controllerAction, "_blank");
        }
    }
}

interface ISideMenuItemProps {
    item: MenuItemApiModel;
    active: Boolean;
    menuItem: string;
    itemClicked: (item: MenuItemApiModel) => void;
    itemMiddleClicked?: (item: MenuItemApiModel) => void;
}

export class SideMenuItem extends React.Component<ISideMenuItemProps> {
    render() {
        let resource = RioResources.find(this.props.item.resourceName);
        if (!resource) return null;

        return (
            <div className={"sideMenuMainItem" + (this.props.active ? " active" : "")} data-menu={this.props.menuItem} onClick={() => this.props.itemClicked(this.props.item)}>
                <RioUnsafe html={resource.image} /><br />
                <span className="text">{resource.text}</span>
            </div>
        );
    }
}

interface ISideMenuSubItemProps {
    item: MenuItemApiModel;

    itemClicked: (item: MenuItemApiModel) => void;
    itemMiddleClicked?: (item: MenuItemApiModel) => void;
}

export class SideMenuSubItem extends React.Component<ISideMenuSubItemProps> {
    constructor(props: ISideMenuSubItemProps) {
        super(props);

        this.handleMouseUp = this.handleMouseUp.bind(this);
    }
    
    render() {
        let resource = RioResources.find(this.props.item.resourceName);
        if (!resource) return null;

        if (!!this.props.item.childItems && this.props.item.childItems.length > 0) {
            return (
                <React.Fragment>
                    <div className="sideMenuSubHeading">
                        <span className="text">{resource.text}</span>
                    </div>
                    <RioForEach items={this.props.item.childItems} perform={(item: MenuItemApiModel) => {
                        return <SideMenuSubItem item={item} itemClicked={(item) => this.props.itemClicked(item)} itemMiddleClicked={this.props.itemMiddleClicked} key={item.menuItemID} />;
                    }} />
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="sideMenuSubItem" onClick={() => this.props.itemClicked(this.props.item)} onMouseUp={this.handleMouseUp}>
                        <span className="text">{resource.text}</span>
                        <div className="sideMenuSubItemSelectedIndicator"></div>
                    </div>
                    <div className="sideMenuSubItemSeperator"></div>
                </React.Fragment>
            );
        }
    }

    handleMouseUp(e: React.MouseEvent) {
        if (e.button === 1 && !!this.props.itemMiddleClicked) {
            e.preventDefault();
            this.props.itemMiddleClicked(this.props.item);
        }
    }
}